import React from 'react';
import SEO from '../../components/SEO/SEO';
import EmployerSection from '../../components/EmployerSection/EmployerSection';
import { getBreadcrumbStructuredData } from '../../components/SEO/StructuredData';
import './Employer.css';

const Employer = () => {
  const structuredData = [
    getBreadcrumbStructuredData([
      { name: 'Home', url: 'https://adamanthr.com' },
      { name: 'Employers', url: 'https://adamanthr.com/employers' },
    ]),
  ];

  return (
    <>
      <SEO
        title="Employers - Hiring Solutions | Adamant HR Noida"
        description="Employers: Partner with Adamant HR for staffing, recruitment, and workforce solutions. Submit your hiring needs and we'll connect you with top talent."
        keywords="employer hiring, staffing solutions employers, recruitment services, workforce solutions, hire talent India, Adamant HR employers"
        url="https://adamanthr.com/employers"
        structuredData={structuredData}
      />

      <div className="employer-page">
        <EmployerSection />
      </div>
    </>
  );
};

export default Employer;
